import { BackgroundContext } from "@/lib/background/context"
import { consumeContext } from "@/lib/consume/context"

export const consumeBackground = consumeContext({
  Context: BackgroundContext,
  provideTo: `background`,
})
